document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-job-carousel]').forEach((root) => {
    const viewport = root.querySelector('.job-media-carousel__viewport');
    const track = root.querySelector('.job-media-carousel__track');
    const slides = Array.from(root.querySelectorAll('.job-media-carousel__slide'));
    const dots = Array.from(root.querySelectorAll('.job-media-carousel__dot'));
    const prev = root.querySelector('.job-media-carousel__btn--prev');
    const next = root.querySelector('.job-media-carousel__btn--next');

    if (!viewport || !track || slides.length === 0) return;

    const realCount = slides.length;
    const CLONE_COUNT = Math.min(2, realCount);

    slides.forEach((s, i) => {
      s.dataset.realIndex = String(i);
      s.dataset.clone = 'false';
    });

    const cloneSlide = (el) => {
      const c = el.cloneNode(true);
      c.dataset.realIndex = el.dataset.realIndex || '0';
      c.dataset.clone = 'true';
      c.setAttribute('aria-hidden', 'true');
      if (c.id) c.removeAttribute('id');
      const videos = c.querySelectorAll('video');
      videos.forEach((v) => { v.removeAttribute('autoplay'); v.pause && v.pause(); });
      return c;
    };

    const headClones = slides.slice(0, CLONE_COUNT).map(cloneSlide);
    const tailClones = slides.slice(-CLONE_COUNT).map(cloneSlide);
    tailClones.slice().reverse().forEach((c) => track.insertBefore(c, track.firstChild));
    headClones.forEach((c) => track.appendChild(c));

    const allSlides = Array.from(track.querySelectorAll('.job-media-carousel__slide'));

    let activeIndex = 0;
    let isTransitioning = false;
    let transitionTimer = null;

    const syncDots = (idx) => {
      if (idx === -1 || idx === activeIndex) return;
      activeIndex = idx;
      dots.forEach((dot, i) => {
        const isActive = i === idx;
        dot.classList.toggle('is-active', isActive);
        if (isActive) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    // Scroll viewport so that target slide is centered — uses scrollTo() for reliable horizontal-only scrolling
    const scrollToSlide = (target, behavior) => {
      const vRect = viewport.getBoundingClientRect();
      const tRect = target.getBoundingClientRect();
      const targetScrollLeft = viewport.scrollLeft + tRect.left - vRect.left - (vRect.width - tRect.width) / 2;
      viewport.scrollTo({ left: targetScrollLeft, behavior });
    };

    const goTo = (idx, behavior = 'smooth') => {
      const normalized = ((idx % realCount) + realCount) % realCount;
      const target = track.querySelector(`.job-media-carousel__slide[data-real-index="${normalized}"][data-clone="false"]`);
      if (target) {
        isTransitioning = true;
        if (transitionTimer) clearTimeout(transitionTimer);
        syncDots(normalized);
        scrollToSlide(target, behavior);
        transitionTimer = setTimeout(() => { isTransitioning = false; }, behavior === 'smooth' ? 800 : 50);
      }
    };

    const getCenteredSlide = () => {
      const vRect = viewport.getBoundingClientRect();
      const center = vRect.left + vRect.width / 2;
      let minDistance = Infinity;
      let best = null;
      allSlides.forEach((s) => {
        const rect = s.getBoundingClientRect();
        const sCenter = rect.left + rect.width / 2;
        const dist = Math.abs(center - sCenter);
        if (dist < minDistance) { minDistance = dist; best = s; }
      });
      return best;
    };

    const syncOnScroll = () => {
      if (isTransitioning) return;
      const centered = getCenteredSlide();
      if (!centered) return;
      const realIdx = Number(centered.dataset.realIndex || '0');
      syncDots(realIdx);
      if (centered.dataset.clone === 'true') {
        const realTarget = track.querySelector(`.job-media-carousel__slide[data-real-index="${realIdx}"][data-clone="false"]`);
        if (realTarget) {
          isTransitioning = true;
          requestAnimationFrame(() => {
            scrollToSlide(realTarget, 'auto');
            transitionTimer = setTimeout(() => { isTransitioning = false; }, 50);
          });
        }
      }
    };

    let scrollTimer;
    viewport.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncOnScroll, 50);
    }, { passive: true });

    prev?.addEventListener('click', (e) => {
      e.preventDefault();
      goTo(activeIndex > 0 ? activeIndex - 1 : realCount - 1);
    });

    next?.addEventListener('click', (e) => {
      e.preventDefault();
      goTo(activeIndex < realCount - 1 ? activeIndex + 1 : 0);
    });

    dots.forEach((dot, i) => {
      dot.addEventListener('click', (e) => { e.preventDefault(); goTo(i); });
    });

    // Jump to first real slide — tail clones are prepended so default scrollLeft shows them
    requestAnimationFrame(() => goTo(0, 'auto'));
  });
});
